<template>
  <q-page padding>
    <p><b>Nethereum-CodeGenerator</b></p>
    <br>
    <p>Used NPMs</p>
    <ul>
      <li>
        <a href="https://www.npmjs.com/package/solcjs-lightweight">solcjs-lightweight</a>
      </li>
      <li>
        <a href="https://ejs.co/">ejs</a>
      </li>
      <li>
        <a href="https://github.com/eligrey/FileSaver.js/">file-saver</a>
      </li>
      <li>
        <a href="https://github.com/gluons/vue-highlight.js">vue-highlight.js</a>
      </li>
    </ul>
    <br>
    <br>
    <br>
    GitHub page: <a href="https://github.com/StefH/Nethereum-CodeGenerator">Nethereum-CodeGenerator</a>
  </q-page>
</template>

<script>
export default {
  name: 'PageAbout',
};
</script>
